<template>
  <el-form-item
    :label-width="option.labelWidth"
    :label="option.langKey ? $t(option.langKey) : option.label"
    :prop="option.prop"
    :class="className"
  >
    <!--输入框-->
    <el-tooltip
      :disabled="option.type == 'textarea' || !value[option.prop]"
      class="item"
      effect="dark"
      :content="option.type == 'input' ? String(value[option.prop]) : ''"
      placement="top"
      v-if="option.type == 'input' || option.type == 'textarea'"
    >
      <el-input
        :style="{ width: option.moreInput ? '50%' : '100%' }"
        v-if="option.type == 'input'"
        :type="option.inputType"
        :maxlength="option.maxlength || 32"
        :value="value[option.prop]"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :clearable="option.clearable || true"
        :disabled="getDisabled(option)"
        @mousewheel.native.prevent
        @change="(val) => handleBlurChange(val, option.prop, option)"
        @input="(val) => handleChange(val, option.prop, option)"
        class="my-el-input"
      >
        <template v-if="option.append" slot="append">{{ option.append }}</template>
        <template v-if="option.prepend" slot="prepend">{{ option.prepend }}</template>
        <el-button
          v-if="option.router"
          @click="handleLinkOther(option.router)"
          slot="append"
          icon="el-icon-link"
        ></el-button>
      </el-input>
      <!-- 文本域 -->
      <el-input
        v-if="option.type == 'textarea'"
        type="textarea"
        :maxlength="option.maxlength || 32"
        :value="value[option.prop]"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :clearable="option.clearable || true"
        :disabled="getDisabled(option)"
        @mousewheel.native.prevent
        @input="(val) => handleChange(val, option.prop, option)"
        class="my-el-input"
      >
        <template v-if="option.append" slot="append">{{ option.append }}</template>
        <template v-if="option.prepend" slot="prepend">{{ option.prepend }}</template>
      </el-input>
    </el-tooltip>
    <!--金额 保留6位小数 显示两位的输入框-->
    <el-tooltip
      :disabled="!value[option.prop]"
      class="item"
      effect="dark"
      :content="String(value[option.prop])"
      placement="top"
      v-if="option.type == 'amountNumber'"
    >
      <input-number-ad
        :style="{ width: option.moreInput ? '50%' : '100%' }"
        :clearable="true"
        :disabled="getDisabled(option)"
        :maxlength="option.maxlength"
        :value="value[option.prop]"
        :precision="option.precision == '0' ? 0 : option.precision || 2"
        :min="option.min"
        :max="option.max || '99999999999.999999'"
        :append="option.append"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.prop, option)"
        @change="(val) => handleBlurChange(val, option.prop, option)"
        class="my-el-input"
      >
      </input-number-ad>
    </el-tooltip>
    <!--保留6位小数的输入框-->
    <el-tooltip
      :disabled="!value[option.prop]"
      class="item"
      effect="dark"
      :content="String(value[option.prop])"
      placement="top"
      v-if="option.type == 'sixNumber'"
    >
      <input-number
        :style="{ width: option.moreInput ? '50%' : '100%' }"
        :clearable="true"
        :disabled="getDisabled(option)"
        :maxlength="option.maxlength"
        :value="value[option.prop]"
        :precision="option.precision == '0' ? 0 : option.precision || 6"
        :min="option.min"
        :max="option.max || '99999999999.999999'"
        :append="option.append"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.prop, option)"
        @change="(val) => handleBlurChange(val, option.prop, option)"
        class="my-el-input"
      >
      </input-number>
    </el-tooltip>
    <el-tooltip
      :disabled="!value[option.prop]"
      class="item"
      effect="dark"
      :content="String(value[option.prop])"
      placement="top"
      v-if="option.type == 'inputNumber'"
    >
      <el-input-number
        :style="{ width: option.moreInput ? '50%' : '100%' }"
        :value="value[option.prop]"
        :controls="option.controls"
        :precision="option.precision"
        :min="option.min"
        :max="option.max"
        controls-position="right"
        :disabled="getDisabled(option)"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.prop, option)"
      ></el-input-number>
    </el-tooltip>
    <el-tooltip
      :disabled="!value[option.moreProp]"
      class="item"
      effect="dark"
      :content="String(value[option.moreProp])"
      placement="top"
      v-if="option.moreInput"
    >
      <input-number
        v-if="option.hasOwnProperty('moreType') && option.moreType == 'number'"
        style="width: 50%; float: right"
        :clearable="true"
        :disabled="option.moreDisabled"
        maxlength="32"
        :value="value[option.moreProp]"
        :precision="option.morePrecision == '0' ? 0 : option.morePrecision || 6"
        :min="option.moreMin || 0"
        :max="option.moreMax || '99999999999.999999'"
        :placeholder="option.morePlaceholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.moreProp, option)"
        class="border-box p-l"
      >
      </input-number>
      <el-input
        v-if="!option.hasOwnProperty('moreType')"
        style="width: 50%; float: right"
        class="border-box p-l"
        :clearable="true"
        :value="value[option.moreProp]"
        :disabled="option.moreDisabled"
        :placeholder="option.morePlaceholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.moreProp, option)"
        :maxlength="32"
      >
        <template v-if="option.moreLabel" slot="prepend">{{ option.moreLabel }}</template>
      </el-input>
    </el-tooltip>
    <!--下拉选择-->
    <el-tooltip
      :disabled="!value[option.prop]"
      class="item"
      effect="dark"
      :content="
        value[option.prop] && option.options[0]
          ? option.valueKey && option.labelKey
            ? option.options.find((item) => item[option.valueKey] == value[option.prop])[
                option.labelKey
              ]
            : option.options.find((item) => item['value'] == value[option.prop])
            ? option.options.find((item) => item['value'] == value[option.prop])['label']
            : ''
          : ''
      "
      placement="top"
      v-if="option.type == 'select'"
    >
      <el-select
        :style="{ width: option.moreInput ? '50%' : '100%' }"
        :value="value[option.prop]"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :multiple="option.multiple || false"
        :clearable="$utils.isBoolean(option.clearable) ? option.clearable : true"
        :filterable="option.filterable || true"
        :disabled="getDisabled(option)"
        @change="(val) => handleChange(val, option.prop, option)"
      >
        <el-option
          v-for="(item, index) in option.options"
          :key="index"
          :value="item[option.valueKey] || item.value"
          :label="item[option.labelKey] || item.label"
        >
          <span v-if="option.expandLabel">{{
            item[option.labelKey] || item.label + '-' + item[option.valueKey] || item.value
          }}</span>
        </el-option>
      </el-select>
    </el-tooltip>
    <!--下拉选择-->
    <el-tooltip
      :disabled="!value[option.prop]"
      class="item"
      effect="dark"
      :content="
        value[option.prop]
          ? option.options.find((item) => item['value'] === value[option.prop])['label']
          : ''
      "
      placement="top"
      v-if="option.type == 'enumSelect'"
    >
      <enum-select
        :value="value[option.prop]"
        :options="option.options"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :multiple="option.multiple || false"
        :clearable="option.clearable || false"
        :filterable="option.filterable || false"
        :disabled="getDisabled(option)"
        @input="(val) => handleChange(val, option.prop, option)"
      >
      </enum-select>
    </el-tooltip>
    <!--获取后端数据渲染的下拉框-->
    <ajax-select
      :style="{ width: option.moreInput ? '50%' : '100%' }"
      v-if="option.type == 'ajaxSelect' || option.type == 'dictSelect'"
      :type="option.type"
      :value="ajaxSelectValue(option)"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      :apiUrl="option.apiUrl"
      :apiData="option.apiData"
      :multiple="option.multiple || false"
      :clearable="option.clearable || false"
      :filterable="option.filterable || false"
      @change="(val) => handleChange(val, option.prop, option)"
      :dataString="option.dataString"
      :valueKey="option.valueKey"
      :labelKey="option.labelKey"
      :method="option.method"
      :moreShowKey="option.moreShowKey"
      :disabled="getDisabled(option)"
      :valueType="option.valueType"
      :isFocus="option.isFocus"
    ></ajax-select>
    <!--单独一个checkbox-->
    <el-checkbox
      v-if="option.type == 'checkbox'"
      :disabled="getDisabled(option)"
      :value="value[option.prop]"
      @change="(val) => handleChange(val, option.prop, option)"
      >{{ option.text }}</el-checkbox
    >
    <!-- checkbox带按钮 -->
    <div class="item" v-if="option.type == 'checkboxButton'">
      <el-checkbox
        :disabled="getDisabled(option)"
        :value="value[option.prop]"
        @change="(val) => handleChange(val, option.prop, option)"
        >{{ option.text }}</el-checkbox
      >
      <el-button
        style="margin-left: 20px; height: 30px"
        type="primary"
        v-if="option.moreBtn || false"
        @click="handleChange((val = null), option.prop + 'button', option)"
        >{{ $t('salePurchase.search.credit') }}</el-button
      >
    </div>
    <!--日期-->
    <el-date-picker
      :clearable="option.clearable"
      :disabled="getDisabled(option)"
      style="width: 100%"
      v-if="option.type == 'date'"
      :value="value[option.prop]"
      type="date"
      :picker-options="option.pickerOptions || {}"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      value-format="yyyy-MM-dd"
      @input="(val) => handleChange(val, option.prop, option)"
    ></el-date-picker>
    <!--开始日期-->
    <el-date-picker
      v-if="option.type == 'startDate'"
      :clearable="option.clearable"
      :disabled="getDisabled(option)"
      style="width: 100%"
      :value="value[option.prop]"
      type="date"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      value-format="yyyy-MM-dd"
      :picker-options="pickerStartOptions"
      @focus="() => handleFocusDate('start', option.prop)"
      @input="(val) => handleChange(val, option.prop, option)"
    ></el-date-picker>
    <!--结束日期-->
    <el-date-picker
      v-if="option.type == 'endDate'"
      :clearable="option.clearable"
      :disabled="getDisabled(option)"
      style="width: 100%"
      :value="value[option.prop]"
      type="date"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      value-format="yyyy-MM-dd"
      :picker-options="pickerEndOptions"
      @focus="() => handleFocusDate('end', option.prop)"
      @input="(val) => handleChange(val, option.prop, option)"
    ></el-date-picker>
    <!--日期：年份-->
    <el-date-picker
      :clearable="option.clearable"
      :disabled="getDisabled(option)"
      style="width: 100%"
      v-if="option.type == 'dateYear'"
      :value="value[option.prop]"
      type="year"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      value-format="yyyy"
      @input="(val) => handleChange(val, option.prop, option)"
    ></el-date-picker>
    <!--弹窗搜索-->
    <el-tooltip
      v-if="option.type == 'searchTable'"
      :disabled="!option.currentValue && !value[option.name]"
      class="item"
      effect="dark"
      :content="option.currentValue || value[option.name]"
      placement="top"
    >
      <search-table
        :value="value[option.prop]"
        :searchType="option.searchType"
        :initShow="option.initShow"
        :isMultiple="option.isMultiple"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :currentValue="option.currentValue || value[option.name]"
        :checkRowKeys="option.checkRowKeys || [value[option.code]]"
        :extraData="option.extraData"
        :propName="option.propName"
        :parseExtendMap="option.parseExtendMap"
        @input="(val) => handleChange(val, option.prop, option)"
        :disabled="option.disabled ? option.disabled : disabled"
        :isLink="option.isLink"
      ></search-table>
    </el-tooltip>
    <!-- 弹框加链接搜索 -->
    <el-tooltip
      v-if="option.type == 'searchTableLink'"
      :disabled="!option.currentValue && !value[option.name]"
      class="item"
      effect="dark"
      :content="option.currentValue || value[option.name]"
      placement="top"
    >
      <search-table
        :value="value[option.prop]"
        :searchType="option.searchType"
        :isMultiple="option.isMultiple"
        :placeholder="option.placeholder || getPlaceHolder(option)"
        :currentValue="option.currentValue || value[option.name]"
        :checkRowKeys="option.checkRowKeys || [value[option.code]]"
        :propName="option.propName"
        :extraData="option.extraData"
        @input="(val) => handleChange(val, option.prop, option)"
        :disabled="option.disabled"
        class="linkInputWidth"
      ></search-table>
    </el-tooltip>
    <el-dropdown v-if="option.type == 'searchTableLink'" trigger="click" @command="handleLink">
      <!-- <el-button size="mini" type="primary" icon="el-icon-paperclip"></el-button> -->
      <i class="icon-link el-icon-paperclip"></i>
      <el-dropdown-menu
        slot="dropdown"
        v-if="value[option.prop] && value[option.linkData.getQueryKey]"
      >
        <el-dropdown-item
          :command="
            option.linkData.getQueryKey
              ? value[option.linkData.getQueryKey].split(',')[index]
              : item
          "
          v-for="(item, index) in value[option.prop].split(',')"
          :key="index"
          >{{ item }}</el-dropdown-item
        >
      </el-dropdown-menu>
      <el-dropdown-menu slot="dropdown" v-else></el-dropdown-menu>
    </el-dropdown>
    <!-- 字典下拉 -->
    <el-select
      :style="{ width: option.moreInput || option.moreDict || option.moreSelect ? '50%' : '100%' }"
      v-if="option.type == 'dict'"
      :value="value[option.prop]"
      :placeholder="option.placeholder || getPlaceHolder(option)"
      :multiple="option.multiple || false"
      :clearable="option.clearable || true"
      :filterable="option.filterable || true"
      :disabled="getDisabled(option)"
      @change="(val) => handleChange(val, option.prop, option)"
    >
      <el-option
        v-for="(item, index) in dictList"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>

    <!--tree-->
    <tree-select
      style="width: 100%"
      ref="treeSelect"
      v-if="option.type == 'treeSelect'"
      :model="option.prop"
      :apiUrl="option.apiUrl"
      :apiData="option.apiData"
      :clearable="option.clearable || true"
      :currentValue="option.currentValue || null"
      :returnType="option.returnType || ''"
      :disabled="option.disabled"
      @setSearchModal="setSearchModal"
    ></tree-select>
    <!-- 紧跟前一个输入框后的文本输入框 -->
    <!--  <el-input
        style="width: 50%; float: right"
        class="border-box p-l"
        v-if="option.moreInput"
        :value="value[option.moreProp]"
        :disabled="option.moreDisabled"
        :placeholder="option.morePlaceholder || getPlaceHolder(option)"
        @input="(val) => handleChange(val, option.moreProp, option)"
        :maxlength="option.moreMaxlength||32"
      >
        <template v-if="option.moreLabel" slot="prepend">{{option.moreLabel}}</template>
      </el-input> -->
    <!-- 紧跟前一个输入框后的字典下拉选择 -->
    <el-select
      style="width: 50%; float: right"
      class="border-box p-l"
      v-if="option.moreDict"
      :value="value[option.moreProp]"
      :disabled="option.moreDisabled"
      :placeholder="option.morePlaceholder || getPlaceHolder(option)"
      :multiple="option.moreMultiple || false"
      :clearable="option.moreClearable || true"
      :filterable="option.moreFilterable || true"
      @change="(val) => handleChange(val, option.moreProp, option)"
    >
      <el-option
        v-for="(item, index) in moreDictList"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>

    <!-- 紧跟前一个输入框后的下拉选择 -->
    <el-select
      style="width: 50%; float: right"
      class="border-box p-l"
      v-if="option.moreSelect"
      :value="value[option.moreProp]"
      :disabled="option.moreDisabled"
      :placeholder="option.morePlaceholder || getPlaceHolder(option)"
      :multiple="option.moreMultiple || false"
      :clearable="option.moreClearable || true"
      :filterable="option.moreFilterable || true"
      @change="(val) => handleChange(val, option.moreProp, option)"
    >
      <el-option
        v-for="(item, index) in option.moreOptions"
        :key="index"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
  import { mapState } from 'vuex';
  import ajaxSelect from '@/components/form-item/ajax-select';
  // import inputRange from '@/components/form-item/input-range';
  import searchTable from '@/components/form-item/search-table';
  import inputNumber from '@/components/form-item/input-number';
  import enumSelect from '@/components/form-item/enum-select';
  import treeSelect from '@/components/form-item/tree-select';
  import inputNumberAd from '@/components/form-item/input-number-advance';

  export default {
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      option: {
        type: Object,
        default: () => {},
      },
      className: {
        type: String,
        default: '',
      },
      relationOption: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ajaxSelect,
      // inputRange,
      searchTable,
      inputNumber,
      enumSelect,
      treeSelect,
      inputNumberAd,
    },
    data() {
      return {
        pickerStartOptions: {}, // 开始日期配置
        pickerEndOptions: {}, // 结束日期配置
      };
    },
    computed: {
      ...mapState({
        dictList(state) {
          let dictType = this.option.dictType;
          if (state.dict.dictList.find((it) => it.dictType == dictType)) {
            return state.dict.dictList.find((it) => it.dictType == dictType).dictList;
          }
        },
        moreDictList(state) {
          let dictType = this.option.moreDictType;
          if (state.dict.dictList.find((it) => it.dictType == dictType)) {
            let dictList = state.dict.dictList.find((it) => it.dictType == dictType).dictList;
            return dictList;
          }
        },
      }),
      inputTip() {
        return this.$t('search.input');
      },
      selectTip() {
        return this.$t('search.choose');
      },
    },
    methods: {
      //设置表单值
      setSearchModal(model, row) {
        console.log(model, row);
        /* if (model == "isFixedPrice") {
        if (row == 0) {
          this.params["pricingRule"] = null;
        }
        this.$refs.queryFrom.clearValidate("pricingRule");
        this.params[model] = row;
      } else if (model == "contractBusinessDepartment") {
        //如果是业务部门
        this.params[model] = row.id;
        this.params.contractBusinessDepartmentName = row.label;
      } else {
        this.params[model] = row;
      } */
      },
      getDisabled(option) {
        if (typeof option.disabled == 'function') {
          return option.disabled(this.value, this.$route);
        } else {
          return option.disabled ? true : false;
        }
      },
      getPlaceHolder(option) {
        // 已禁用的选项不展示 placeholder
        if (this.disabled || this.getDisabled(option)) {
          return '';
        }
        const inputArr = ['sixNumber', 'input', 'textarea', 'inputNumber'];
        const label = option.langKey ? this.$t(option.langKey) : option.label;
        return (
          (inputArr.indexOf(option.type) > -1 ? this.inputTip : this.selectTip) + (label || '')
        );
      },
      ajaxSelectValue(option) {
        return this.value[option.prop];
        /* if (option.valueType == 'object' && this.value[option.name] && this.value[option.code]) {
        return {
          [option.labelKey || 'label']: this.value[option.name],
          [option.valueKey || 'value']: this.value[option.code]
        }
      } else {
        return this.value[option.prop]
      } */
      },
      handleFocusDate(type) {
        const dateProp = this.relationOption.prop;
        const pickerOptions = {
          disabledDate: (time) => {
            return this.disabledDate(time, dateProp, type);
          },
        };
        if (type == 'start') {
          this.pickerStartOptions = pickerOptions;
        } else {
          this.pickerEndOptions = pickerOptions;
        }
      },
      // 开始结束日期禁用日期
      disabledDate(time, prop, type) {
        if (type === 'end') {
          let startDate = this.value[prop];
          if (startDate) {
            return time.getTime() < new Date(startDate).getTime();
          }
        } else {
          let endDate = this.value[prop];
          if (endDate) {
            return time.getTime() > new Date(endDate).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      handleChange(newValue, prop, item) {
        if (item.canZero && newValue == 0) {
          newValue = 0;
        }
        const more = {};
        // 选择弹窗单选
        if (item.name && item.code && item.type == 'searchTable' && item.isMultiple) {
          if (item.getName && newValue && newValue[0]) {
            more[item.name] = newValue[0][item.getName];
            more[item.code] = newValue[0][item.getCode];
            more[item.id] = newValue[0][item.id] || '';
          }
        }
        // 下拉选择需要value label数据
        if (
          item.type == 'ajaxSelect' &&
          item.valueType == 'object' &&
          newValue !== null &&
          newValue !== undefined &&
          typeof newValue == 'object'
        ) {
          more[item.name] = newValue[item.labelKey || 'label'];
          more[item.code] = newValue[item.valueKey || 'value'];
        }
        this.$emit(
          'input',
          {
            [prop]: newValue,
            ...more,
          },
          prop
        );
      },
      // 失去焦点
      handleBlurChange(newValue, prop, item) {
        const more = {};
        // 选择弹窗单选
        if (item.name && item.code && item.type == 'searchTable' && item.isMultiple) {
          if (item.getName && newValue[0]) {
            more[item.name] = newValue[0][item.getName];
            more[item.code] = newValue[0][item.getCode];
            more[item.id] = newValue[0][item.id] || '';
          }
        }
        // 下拉选择需要value label数据
        if (
          item.type == 'ajaxSelect' &&
          item.valueType == 'object' &&
          typeof newValue == 'object'
        ) {
          more[item.name] = newValue[item.labelKey || 'label'];
          more[item.code] = newValue[item.valueKey || 'value'];
        }
        this.$emit(
          'change',
          {
            [prop]: newValue,
            ...more,
          },
          prop
        );
      },
      handleLink(command) {
        let query = {};
        if (this.option.linkData.queryKey) {
          query[this.option.linkData.queryKey] = command;
        } else {
          query.id = command;
        }
        if (this.option.linkData.extraQuery) {
          query = {
            ...query,
            ...this.option.linkData.extraQuery,
          };
        }
        let path = {
          path: this.option.linkData.path,
          name: this.option.linkData.name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleLinkOther(router) {
        this.$emit('goRouter', router);
      },
    },
  };
</script>
<style lang="scss">
  .linkInputWidth {
    float: left;
    width: calc(100% - 20px);
  }
  .icon-link {
    position: relative;
    top: 4px;
    font-size: 20px;
    color: #409eff;
    cursor: pointer;
  }
</style>
